import {_} from 'lodash';
import * as ko from "knockout";
import {hasher} from 'hasher'
import {Menu, MenuGroups} from "./_def";
import {getEadmRole} from "../../../util/misc";
import {global, lm} from "../../../appContext";
import {customStoreObservable, storeObservable} from "../../../util/sessionstore";
import {getTabHash, isTabHashForShellParent} from "../../../util/pageShellRoute";
import {ILatestObject} from "./LatestObjectsManager";
import {IButton, IRouteDefinition, IRouteParams, TBaseOrObservableType, TRouteId} from "../../../index";
import {
    getHash,
    getRouteButton,
    getRouteDefinition,
    getRouteDefinitions,
    getRouteHash,
    getRouteLabel,
    isRoutePermissionOkay
} from "../../../constants/RouteDefinitions";
import {ObjectTypeId, Permission, WIN_NAME_IFRAME} from "../../../constants";
import {IExpressionBuilderParams} from "../../dynamic-variable/dialog/builder";
import {nsRoute} from "../../../util/route";
import detailsHtml from './details.html?raw';

export let template = detailsHtml;

interface IMenuItem {
    button?: IButton
    create: ILinkAttr | null
    createWizard: ILinkAttr | null
    def: IRouteDefinition | null
    defCreate: IRouteDefinition | null
    defCreateWizard: IRouteDefinition | null
    defEdit: IRouteDefinition | null
    edit: ILinkAttr | null
    id: TRouteId | null
    latestGroups: IMenuLatestGroup[] | null
    read: ILinkAttr | null
    click?: () => void,
    customButtons?: IButton[]
}

interface ILinkAttr {
    title?: TBaseOrObservableType<IRouteDefinition['labelLong']>
    href: string | null
}

interface IMenuLatestObject {
    obj: ILatestObject
    def: IRouteDefinition | null
    defEdit: IRouteDefinition | null
    read: ILinkAttr | null
    edit: ILinkAttr | null
    runDisplay?: {
        delta?: boolean
        icon?: string
        title: string
    } | undefined
}

interface IMenuLatestGroup {
    label: string | null
    items: IMenuLatestObject[]
    listRouteId: TRouteId | null
    parentRouteId: TRouteId
    read: ILinkAttr | null
}

interface IMenuItemGroup {
    groupLabel: string
    groupIcon: string
    items: IMenuItem[]
    expanded: KnockoutObservable<boolean>
}

export class viewModel {
    private static readonly LATEST_SUBITEM_GROUP_LABELS: Partial<Record<TRouteId, string>> = {
        synctemplatedetails: 'nav-left.latest.synctemplates',
        importhistorydetails: 'nav-left.latest.recentruns',
    };

    private static readonly LATEST_SUBITEM_LIST_ROUTES: Partial<Record<TRouteId, TRouteId>> = {
        synctemplatedetails: 'synctemplatesearch',
        importhistorydetails: 'importhistorysearch',
    };

    private readonly isLoggedIn: KnockoutComputed<boolean> = ko.pureComputed((): boolean => {
        return global.login.isLoggedIn();
    });
    private readonly isTranslationsReady: KnockoutComputed<boolean> = ko.pureComputed((): boolean => {
        return !!lm.isReady();
    });
    private readonly toggle: KnockoutObservable<boolean> = storeObservable('layout.left.toggle');

    private activeFlyout: KnockoutObservable<number> = ko.observable(-1);
    private activeFlyoutRect: KnockoutObservable<DOMRect | null> = ko.observable(null);

    private flyoutStyle = ko.pureComputed(() => {
        const rect = this.activeFlyoutRect();
        if (!rect) return null;
        return { top: rect.top + 'px', left: (rect.right + 4) + 'px' };
    });

    private readonly _closeFlyoutHandler = (e: MouseEvent) => {
        const target = e.target as HTMLElement;
        if (!target.closest('.menu-group')) {
            this.activeFlyout(-1);
            this.activeFlyoutRect(null);
        }
    };

    constructor() {
        document.addEventListener('click', this._closeFlyoutHandler);
    }

    dispose() {
        document.removeEventListener('click', this._closeFlyoutHandler);
    }

    private onGroupIconClick = (index: number, _data: any, event: Event): void => {
        event.stopPropagation();
        if (this.toggle()) {
            this.toggleGroup(index);
        } else {
            const newIndex = this.activeFlyout() === index ? -1 : index;
            if (newIndex !== -1) {
                const el = event.currentTarget as HTMLElement;
                this.activeFlyoutRect(el.getBoundingClientRect());
            } else {
                this.activeFlyoutRect(null);
            }
            this.activeFlyout(newIndex);
        }
    }

    private resolveLatestObjectEntityId(routeId: TRouteId, params: IRouteParams | undefined): string | number | null {
        if (!params) {
            return null;
        }
        switch (routeId) {
            case 'importhistorydetails':
                return params['importfileid'] ?? null;
            default:
                return params['id'] ?? null;
        }
    }

    private isCurrentRoute(item: IMenuItem | IMenuLatestObject): boolean {
        const a = document.location.hash?.slice?.(2);
        const currentRoute = global.router.currentRoute();
        const b = currentRoute?.__routeId;
        if ('obj' in item) {
            if (item.obj.params.request_ == a) {
                return true;
            }

            if (!currentRoute) {
                return false;
            }
            const currentRouteDef = currentRoute.__routeDef;
            const itemId = item.obj.id;
            const currentId = this.resolveLatestObjectEntityId(item.obj.routeId, currentRoute.__routeParams);

            if (!currentRouteDef || currentId == null || String(currentId) !== String(itemId)) {
                return false;
            }

            let routeDef: IRouteDefinition | null = currentRouteDef;
            const visited: TRouteId[] = [];
            while (routeDef) {
                if (routeDef.id == item.obj.routeId) {
                    return true;
                }
                if (!routeDef.parent || visited.includes(routeDef.id)) {
                    break;
                }
                visited.push(routeDef.id);
                routeDef = getRouteDefinition(routeDef.parent);
            }

            return false;
        } else {
            const cr = global.router.currentRoute();
            if (!cr || b == null) {
                return false;
            }
            return item.id == b
                || item.id == cr.__shellRouteId
                || (item.id != null && isTabHashForShellParent(item.id, b));
        }
    }

    private isRoute(routeId: TRouteId): boolean {
        const cr = global.router.currentRoute();
        if (!cr?.__routeId) {
            return false;
        }
        return cr.__routeId == routeId
            || cr.__shellRouteId == routeId
            || isTabHashForShellParent(routeId, cr.__routeId);
   }

    private groupExpandedStates: KnockoutObservable<boolean>[] = MenuGroups.map(() => ko.observable(true));

    private toggleGroup = (index: number): void => {
        const state = this.groupExpandedStates[index];
        if (!state) {
            return;
        }
        state(!state());
    }

    private menuGroups = ko.pureComputed((): IMenuItemGroup[] => {
        const allItems = this.menuItems();
        const itemById = new Map<TRouteId, IMenuItem>();
        const buttonItems: IMenuItem[] = [];
        for (const item of allItems) {
            if (item.id) {
                itemById.set(item.id, item);
            } else if (item.button) {
                buttonItems.push(item);
            }
        }

        const groups: IMenuItemGroup[] = [];
        const usedIds = new Set<TRouteId>();

        for (let gi = 0; gi < MenuGroups.length; gi++) {
            const g = MenuGroups[gi];
            if (!g) {
                continue;
            }
            const groupItems: IMenuItem[] = [];
            for (const opt of g.items) {
                const ids: TRouteId[] = Array.isArray(opt) ? opt : [opt as TRouteId];
                for (const id of ids) {
                    const item = itemById.get(id);
                    if (item && !usedIds.has(id)) {
                        groupItems.push(item);
                        usedIds.add(id);
                        break;
                    }
                }
            }

            // Expression builder → System administration
            if (gi === MenuGroups.length - 2) {
                groupItems.unshift(...buttonItems);
            }

            groups.push({
                groupLabel: g.groupLabel,
                groupIcon: g.groupIcon,
                items: groupItems,
                expanded: this.groupExpandedStates[gi] ?? ko.observable(true),
            });
        }
        return groups;
    })

    private menuItems = ko.pureComputed((): IMenuItem[] => {
        const selectedOrg = global.login.selectedOrganization();
        const ret = _(Menu)
            .map((opt: IRouteDefinition|IRouteDefinition[]) => {
                if (Array.isArray(opt)) {
                    return opt.find(o => (o.permissionLevel ?? Permission.None) <= getEadmRole(selectedOrg ?? undefined))
                }
                return opt
            })
            .filter(Boolean)
            .filter((def: IRouteDefinition) => (def.permissionLevel ?? Permission.None) <= getEadmRole(selectedOrg ?? undefined))
            .filter((def: IRouteDefinition) => selectedOrg != null && nsRoute.isRouteLicenseOkay(def, selectedOrg))
            .map((def: IRouteDefinition): IMenuItem => {
                const defCreate = def.create && isRoutePermissionOkay(def.create) ? getRouteDefinition(def.create) : null;
                const defEdit = def.edit && isRoutePermissionOkay(def.edit) ? getRouteDefinition(def.edit) : null;
                const defCreateWizard = def.createWizard && isRoutePermissionOkay(def.createWizard) ? getRouteDefinition(def.createWizard) : null;
                const ret: IMenuItem = {
                    id: def.id,
                    def: def,
                    defCreate: defCreate,
                    defCreateWizard: defCreateWizard,
                    defEdit: defEdit,
                    latestGroups: [],
                    read: {
                        title: this.toggle() ? getRouteLabel(def) : undefined,
                        href: getRouteHash('read', def),
                    },
                    createWizard: defCreateWizard ? {
                        title: getRouteLabel(defCreateWizard),
                        href: getRouteHash('createWizard', def),
                    } : null,
                    create: defCreate ? {
                        title: getRouteLabel(defCreate),
                        href: getRouteHash('create', def),
                    } : null,
                    edit: defEdit ? {
                        title: getRouteLabel(defEdit),
                        href: getRouteHash('edit', def),
                    } : null,
                };
                ret.latestGroups = this.getLatestObjectGroups(def);
                return ret;
            })
            .value();

        if (global.permissionValidator.isMinCompanyAdmin()) {
            const btn: IButton = {
                icon: 'fa-pencil-ruler',
                label: 'nav-left.section.sysadmin.expressionbuilder',
                onClick: () => this.onCreateExpressionClick(),
                permissionLevel: Permission.CompanyAdmin,
            };

            ret.push({
                button: btn,
                create: null,
                createWizard: null,
                def: null,
                defCreate: null,
                defCreateWizard: null,
                defEdit: null,
                edit: null,
                id: null,
                latestGroups: null,
                read: null,
            })
        }

        let item: IMenuItem

        item = ret.find((o: IMenuItem) => o.id == 'wizardpermissions')
        if (item) {
            const wizardHash = () =>
                getHash('wizardpermissions', {orgnr: global.login.selectedOrganizationId()}, false) ?? '';
            const btn = _.defaultsDeep({
                clickAnchor: () => window.open(`win.html#/${wizardHash()}`, WIN_NAME_IFRAME),
                icon: 'fa-window',
                label: 'open in new window',
                target: WIN_NAME_IFRAME,
                href: () => `win.html#/${wizardHash()}`,
            }, getRouteButton('wizardpermissions'))
            item.customButtons = [btn]
        }

        return ret
    })

    private onCreateExpressionClick() {
        const params: IExpressionBuilderParams = {
            objectTypeIds: [
                ObjectTypeId.Function,
                ObjectTypeId.History,
                ObjectTypeId.Event,
                ObjectTypeId.System,
                ObjectTypeId.Message,
                ObjectTypeId.Ruleset,
                ObjectTypeId.FunctionAlias,
            ],
        }
        global.dialogManager.addCustom({
            name: 'component/dynamic-variable/dialog/builder',
            params: params,
        });
    }

    private mapLatestObject(obj: ILatestObject): IMenuLatestObject {
        const defRead = isRoutePermissionOkay(obj.routeId) ? getRouteDefinition(obj.routeId) : null;
        const defEdit = defRead?.edit && isRoutePermissionOkay(defRead.edit) ? getRouteDefinition(defRead.edit) : null;
        const readLabel = defRead?.label;
        return {
            obj: obj,
            def: defRead,
            defEdit: defEdit,
            runDisplay: this.getImportRunDisplay(obj),
            read: defRead ? {
                title: `${obj.name} [${(lm.t(typeof readLabel === 'function' ? (readLabel() ?? '') : (readLabel ?? '')) ?? '').toLowerCase()}]`,
                href: getRouteHash('read', defRead, obj.params),
            } : null,
            edit: defEdit && defRead ? {
                title: lm.t('Edit') ?? '',
                href: getRouteHash('edit', defRead, obj.params),
            } : null,
        };
    }

    private getImportRunDisplay(obj: ILatestObject): IMenuLatestObject['runDisplay'] {
        if (obj.routeId !== 'importhistorydetails' || obj.sequencenr == null) {
            return undefined;
        }
        if (obj.sequencenr === 0) {
            return {icon: 'fa-repeat-alt', title: 'full synchronization'};
        }
        return {delta: true, title: `((delta synchronization)) #${obj.sequencenr}`};
    }

    private getLatestSubitemListRoute(routeId: TRouteId): TRouteId | null {
        const mapped = viewModel.LATEST_SUBITEM_LIST_ROUTES[routeId];
        if (mapped) {
            return mapped;
        }
        const childRoutes = getRouteDefinitions().filter((def) => def.child === routeId);
        if (childRoutes.length === 1) {
            return childRoutes[0]?.id ?? null;
        }
        if (childRoutes.length > 1) {
            const searchRoute = childRoutes.find((def) => def.isSearch || !!def.serviceName);
            if (searchRoute) {
                return searchRoute.id;
            }
            return childRoutes[0]?.id ?? null;
        }
        const routeParent = getRouteDefinition(routeId)?.parent;
        const parentDef = routeParent ? getRouteDefinition(routeParent) : null;
        if (parentDef?.child === routeId) {
            return parentDef.id;
        }
        return null;
    }

    private isManualLatestSubitem(routeId: TRouteId): boolean {
        if (routeId.includes('manual')) {
            return true;
        }
        return !!getRouteDefinition(routeId)?.manual;
    }

    private getLatestSubitemGroupLabel(routeId: TRouteId, grouped: boolean): string | null {
        if (!grouped) {
            return null;
        }
        const mapped = viewModel.LATEST_SUBITEM_GROUP_LABELS[routeId];
        if (mapped) {
            return mapped;
        }
        if (!this.isManualLatestSubitem(routeId)) {
            return null;
        }
        const listRouteId = this.getLatestSubitemListRoute(routeId);
        const listDef = listRouteId ? getRouteDefinition(listRouteId) : null;
        const routeDef = getRouteDefinition(routeId);
        const label = listDef?.label ?? routeDef?.label;
        if (label == null) {
            return null;
        }
        return typeof label === 'function' ? label() : label;
    }

    private getLatestGroupRead(parentDef: IRouteDefinition, listRouteId: TRouteId): ILinkAttr | null {
        const listRouteDef = getRouteDefinition(listRouteId);
        if (!listRouteDef || !isRoutePermissionOkay(listRouteId)) {
            return null;
        }
        if (!isRoutePermissionOkay(parentDef.id)) {
            return null;
        }
        const href = getTabHash(listRouteId) ?? getRouteHash('read', listRouteDef);
        if (!href) {
            return null;
        }
        return {
            title: getRouteLabel(listRouteDef),
            href,
        };
    }

    private getLatestObjectGroups(def: IRouteDefinition): IMenuLatestGroup[] {
        if (!def.subItems) {
            return [];
        }
        const arr = def.subItems as TRouteId[];
        const manager = global.latestObjectsManager;
        const showLimit = storeObservable('latest.objects.show.limit')();
        const grouped = arr.length > 1;

        return arr
            .map((routeId: TRouteId) => {
                const bookmarked = manager.getListByBookmark(routeId);
                const regular = manager.getListByRegular(routeId).slice(0, showLimit);
                const items = _.sortBy([...bookmarked, ...regular], 'index')
                    .reverse()
                    .map((obj: ILatestObject) => this.mapLatestObject(obj));
                const listRouteId = this.getLatestSubitemListRoute(routeId);
                const label = this.getLatestSubitemGroupLabel(routeId, grouped);
                return {
                    label,
                    items,
                    listRouteId,
                    parentRouteId: def.id,
                    read: label && listRouteId ? this.getLatestGroupRead(def, listRouteId) : null,
                };
            })
            .filter((group) => group.items.length > 0);
    }

    private getTabMemoryKeyForRoute(routeId: TRouteId): TRouteId {
        const routeDef = getRouteDefinition(routeId);
        return routeDef?.tabMemory ?? routeId;
    }

    private isLatestGroupCurrent(group: IMenuLatestGroup): boolean {
        if (!group.listRouteId) {
            return false;
        }
        const currentRoute = global.router.currentRoute();
        if (!currentRoute?.__routeId) {
            return false;
        }
        const routeId = currentRoute.__routeId;
        const shellRouteId = currentRoute.__shellRouteId;
        if (routeId === group.listRouteId || shellRouteId === group.listRouteId) {
            return true;
        }
        const memoryKey = this.getTabMemoryKeyForRoute(group.parentRouteId);
        const currentTab = customStoreObservable(`${memoryKey}.current.tab`)();
        return routeId === group.parentRouteId && currentTab === group.listRouteId;
    }

    private onBookmarkClick(item: IMenuLatestObject) {
        global.latestObjectsManager.toggleBookmark(item.obj);
    }

    private onRemoveLatestObjectClick(item: IMenuLatestObject) {
        global.latestObjectsManager.remove(item.obj);
    }

    private getLoggedInUserHash(): string {
        global.login.user()
        global.router.currentRoute()
        const user = global.login.user();
        if (!user) {
            return '';
        }
        const hash = getHash('userdetails', {id: user.id}, false)
        return hash ?? ''
    }
    
    private isHash(str: string): boolean {
        global.login.user()
        global.router.currentRoute()
        return hasher.getHash() == str
    }

    private showMyProfile = ko.pureComputed((): boolean => {
        return !isRoutePermissionOkay('userstart');
    });
}
